// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__1hw-H","fixedWidthColumn":"styles_fixedWidthColumn__2uSyx","detailStatusColumn":"styles_detailStatusColumn__hHhnt"};